import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import useMartyContext from 'hooks/useMartyContext';

import css from 'styles/components/rating.scss';

const Rating = props => {
  const {
    additionalClasses, includeSeoMetadata, itemReviewed, rating, reviewCount
  } = props;
  const {
    marketplace: { features: { showRatings } = {} },
    testId
  } = useMartyContext();

  if (!showRatings) {
    return null;
  }

  const shouldRenderSeoMetadata = includeSeoMetadata && reviewCount > 0;

  if (!(rating > 0)) {
    return null;
  }

  const outerSpanProps = {
    // We want the stars on the rating to shrink when they come from the MelodyCardProduct component, so check for that prop to add the correct className
    'className': cn(css.rating, additionalClasses),
    'itemScope': true,
    'data-star-rating': rating,
    'data-test-id': testId('rating')
  };
  let ratingMeta = null;
  let itemReviewedMeta = null;

  if (shouldRenderSeoMetadata) {
    outerSpanProps.itemProp = 'aggregateRating';
    outerSpanProps.itemType = 'http://schema.org/AggregateRating';
    ratingMeta = (
      <>
        <meta itemProp="ratingValue" content={rating}/>
        <meta itemProp="reviewCount ratingCount" content={reviewCount}/>
      </>
    );

    if (itemReviewed) {
      itemReviewedMeta = (
        <span itemProp="itemReviewed" itemType="http://schema.org/Product" itemScope>
          <meta itemProp="name" content={itemReviewed}/>
        </span>
      );
    }
  }

  return (
    <span {...outerSpanProps}>
      {itemReviewedMeta}
      {ratingMeta}
      <span className={css.numberOfStars}>{rating}</span>
      <span className="screenReadersOnly">Rated {rating} stars out of 5</span>
    </span>
  );
};

Rating.defaultProps = {
  includeSeoMetadata: true,
  reviewCount: 0
};

Rating.propTypes = {
  additionalClasses: PropTypes.string,
  includeSeoMetadata: PropTypes.bool.isRequired,
  itemReviewed: PropTypes.string,
  // TODO these should really be numbers
  rating: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  reviewCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default Rating;
